var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorsSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.73C12.255 9 9 12.255 9 17.715V30.27C9 35.73 12.255 38.985 17.715 38.985H30.27C35.73 38.985 38.985 35.73 38.985 30.27V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8 27.5995C25.8 29.1895 25.11 30.6295 24 31.6195C23.04 32.4895 21.78 32.9995 20.4 32.9995C17.415 32.9995 15 30.5845 15 27.5995C15 25.1095 16.695 23.0095 18.975 22.3945C19.59 23.9545 20.925 25.1695 22.575 25.6195C23.025 25.7395 23.505 25.8145 24 25.8145C24.495 25.8145 24.975 25.7545 25.425 25.6195C25.665 26.2195 25.8 26.8945 25.8 27.5995Z",
    fill: "#8A8A8A",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4 20.4C29.4 21.105 29.265 21.78 29.025 22.395C28.41 23.955 27.0751 25.17 25.4251 25.62C24.9751 25.74 24.4951 25.815 24.0001 25.815C23.5051 25.815 23.025 25.755 22.575 25.62C20.925 25.17 19.5901 23.97 18.9751 22.395C18.7351 21.78 18.6001 21.105 18.6001 20.4C18.6001 17.415 21.0151 15 24.0001 15C26.9851 15 29.4 17.415 29.4 20.4Z",
    fill: "#111827"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 27.6009C33 30.5859 30.585 33.0009 27.6 33.0009C26.22 33.0009 24.96 32.4759 24 31.6209C25.11 30.6459 25.8 29.2059 25.8 27.6009C25.8 26.8959 25.665 26.2209 25.425 25.6059C27.075 25.1559 28.41 23.9559 29.025 22.3809C31.305 23.0109 33 25.1109 33 27.6009Z",
    fill: "#D7D5D5",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsSquare);
export default __webpack_public_path__ + "static/media/colorsSquare.c1028123640def0a690619dde2458a4f.svg";
export { ForwardRef as ReactComponent };